export enum TransitionStatus {
  BASE = 'BASE',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}
